import moment from "moment";
import { useEffect, useState } from "react";
import { Divider } from "@mui/material";
import Link from "@mui/material/Link";
export default function Footer() {
  const [time, setTime] = useState("");
  let date = moment().format("MMM Do YY");
  useEffect(() => {
    const TimeCalc = setInterval(() => {
      setTime(() => {
        let Time = moment().format("LTS");
        return Time;
      });
    }, 1000);
    return () => clearInterval(TimeCalc);
  }, []);
  return (
    <div
      className="footer"
      style={{
        position: "absolute",
        bottom: "0",
        zIndex: "5",
        color: "white",
        padding: "15px 30px",
        display: "flex",
        width: "100%",
        flexDirection: "row",
        justifyContent: "space-between",
      }}
    >
      <div
        className="fot-row-info"
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "50px",
        }}
      >
        <div
          className="fot-col-info"
          style={{ display: "flex", flexDirection: "column" }}
        >
          <span className="footer-title-span">Today's Date</span>
          <span className="footer-info-span">{date}</span>
        </div>
        <div
          className="fot-col-info"
          style={{ display: "flex", flexDirection: "column" }}
        >
          <span className="footer-title-span">Local Time</span>
          <span className="footer-info-span">{time}</span>
        </div>
      </div>
      <Divider
        className="mobile-footer-hr"
        style={{
          borderColor: "white ",
          margin: "15px 0",
          width: "100%",
          display: "none",
        }}
      />
      <div className="row-social">
        <div
          className="row-social"
          style={{ display: "flex", flexDirection: "column" }}
        >
          <span className="footer-title-span">SOCIALS : </span>
          <div className="social-media-footer">
            <Link
              href="https://www.facebook.com/Taimjr10/"
              target="_blank"
              underline="none"
            >
              <span>Facebook</span>
            </Link>

            <Link
              href="https://wa.me/+963996621746"
              target="_blank"
              underline="none"
            >
              <span>whatsapp</span>
            </Link>

            <Link
              href="https://github.com/Taim-Gr"
              target="_blank"
              underline="none"
            >
              <span>github</span>
            </Link>
            <Link
              href="https://www.linkedin.com/in/taim-jaber-90621237b/"
              target="_blank"
              underline="none"
            >
              <span>linkedin</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
